     $(document).ready(function() {
            $(document).on('click', '.offer_code', function(e) {
                var $this = $(this);
                var copiedText = $this.attr('data-clipboard-text');
                var $copiedStatus = $this.find('.copyStatus');
                   copyToClipboard(copiedText);
              console.log(copiedText);
                // Update copy status text
                $copiedStatus.text('Copied!').fadeIn(200, function() {
                    setTimeout(function() {
                        $copiedStatus.fadeOut(1000);
                    }, 1000); // Fade out after 1 second
                });

               });
                function copyToClipboard(text) {
        var tempTextArea = $('<textarea>');
        tempTextArea.val(text);
        $('body').append(tempTextArea);
        tempTextArea.select();
        document.execCommand('copy');
        tempTextArea.remove()
    }


       //disable qty btn 
       const $quantityInput = $('.quantity__input');
    const $plusButton = $('.quantity__button.plus');
    
    function checkStock() {
        const currentQty = parseInt($quantityInput.val());
        const availableStock = parseInt($quantityInput.data('avl-qty'));
        $plusButton.prop('disabled', currentQty >= availableStock);
    }
    
    // Monitor quantity changes
    $quantityInput.on('change', checkStock);
 });


  document.querySelectorAll("details.sumtabs").forEach(function(detailsEl) {
    const content = detailsEl.querySelector(".rte");
    if (content && content.textContent.trim() === "") {
      detailsEl.style.display = "none";
    }
  });

